import styled from 'styled-components'
import { NAVBAR_HEIGHT, zIndex } from '../../Styles/Metrics'

export const NavBarWrapper = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  position: fixed;
  padding: .5rem 1rem;
  align-items: center;
  background-color: white;
  height: ${NAVBAR_HEIGHT};
  justify-content: flex-end;
  z-index: ${zIndex.navbarFixed};
  border-bottom: 1px solid ${({ theme }) => theme.border};

  img {
    height: 100%;
    width: auto;
  }
`



// WEBPACK FOOTER //
// ./src/Components/NavBar/Styles.js